export default {
  product: {
    nameRequired: '请输入产品名称',
    priceRequired: '请输入产品价格',
    pricePositive: '产品价格必须大于0',
  },
};
